// Used for mobile main menu
document.addEventListener(
  'DOMContentLoaded', () => {
    const menu = new MmenuLight(
      document.querySelector('#manager-menu'),
      '(min-width: 320px)',
    );
    // Init main menu for mobile
    const menuMain = new MmenuLight(
      document.querySelector('#main-menu'),
      '(max-width: 992px)',
    );
    // below is needed for framework, so eslint can ignore
    /* eslint-disable no-unused-vars */
    const navigator = menu.navigation({
      theme: 'dark',
      title: 'Admin Menu',
    });
    // below is needed for framework, so eslint can ignore
    /* eslint-disable no-unused-vars */
    const navigatorMain = menuMain.navigation({
      theme: 'dark',
      title: 'Main Menu',
    });
    const drawer = menu.offcanvas({
      position: 'right',
    });
    const drawerMain = menuMain.offcanvas({
      position: 'left',
    });
    const toggle = (elem) => {
      const drawerOpen = document.querySelector('.mm-ocd.mm-ocd--open');
      if (drawerOpen) {
        jQuery(elem).show();
      }
      else {
        jQuery(elem).hide();
      }
    };

    const managermenu = document.getElementById('adminManagerMenu');
    if (managermenu) {
      managermenu.addEventListener('click', (event) => {
        event.preventDefault();
        drawer.open();
        toggle(document.querySelector('#manager-menu'));
      });
    }
  },
);
